export const PAYMENT_METHOD_TYPES = [
  { value: 'credit_card', label: 'Cartão de crédito' },
  { value: 'debit_card', label: 'Cartão de débito' },
  { value: 'voucher', label: 'Voucher' },
  { value: 'check', label: 'Cheque' },
  { value: 'cash', label: 'Dinheiro' },
  { value: 'pix', label: 'PIX' },
  { value: 'account_transfer', label: 'Transferência bancária' },
]
